export default "__VITE_ASSET__D5SbIXKC__"